import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
import { environment } from "../../../environments/environment";

@Pipe({
  name: "dateFormat",
  pure: false,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, format: string): string {
    if (format) {
      if (format == "Time") format = environment.DateFormat;
    } else format = environment.DateFormat.split(",")[0];
    return moment(value).format(format);
  }
}
